import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { blogAPI } from '../services/api'
import { useNotification } from '../context/NotificationContext'
import { getErrorMessage, getImageUrl, confirmAction } from '../utils/helpers'

const Blog = () => {
  const { showSuccess, showError } = useNotification()
  const [posts, setPosts] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchPosts()
  }, [])

  const fetchPosts = async () => {
    try {
      const response = await blogAPI.getAll()
      setPosts(response.data.posts || [])
    } catch (error) {
      showError(getErrorMessage(error))
    } finally {
      setLoading(false)
    }
  }

  const handleTogglePublish = async (id) => {
    try {
      await blogAPI.toggle(id)
      showSuccess('Post visibility toggled.')
      fetchPosts()
    } catch (error) {
      showError(getErrorMessage(error))
    }
  }

  const handleDelete = async (id) => {
    if (!confirmAction('Delete this blog post?')) return
    
    try {
      await blogAPI.delete(id)
      showSuccess('Post deleted.')
      fetchPosts()
    } catch (error) {
      showError(getErrorMessage(error))
    }
  }

  if (loading) return <div className="admin-page">Loading...</div>

  return (
    <div className="admin-page blog-page">
      <div className="page-head">
        <div>
          <h2 className="admin-title">Blog Posts</h2>
          <p className="admin-sub">Manage your blog posts and Instagram Reels</p>
        </div>
        <Link to="/admin/blog/new" className="btn btn-gold">
          <i className="fa fa-plus"></i> New Post
        </Link>
      </div>

      <div className="panel">
        {posts.length > 0 ? (
          <div className="table-responsive">
            <table className="admin-table">
              <thead>
                <tr className="blog-head-row">
                  <th className="blog-id">ID</th>
                  <th className="blog-title">Title</th>
                  <th className="blog-author">Author</th>
                  <th className="blog-media">Media</th>
                  <th className="blog-published">Published</th>
                  <th className="blog-actions">Actions</th>
                </tr>
              </thead>
              <tbody>
                {posts.map((post) => (
                  <tr key={post.id}>
                    <td className="blog-id" data-label="ID">{post.id}</td>
                    <td className="blog-title" data-label="Title">
                      <Link to={`/admin/blog/${post.id}/edit`}>{post.title}</Link>
                    </td>
                    <td className="blog-author" data-label="Author">{post.author || '—'}</td>
                    <td className="blog-media" data-label="Media">
                      {post.image ? (
                        <img src={getImageUrl(post.image)} alt="" className="thumb" />
                      ) : (
                        <span className="thumb-empty"><i className="fa fa-image"></i></span>
                      )}
                    </td>
                    <td className="blog-published" data-label="Published">
                      <span className={`badge badge-${post.published ? 'success' : 'secondary'}`}>
                        {post.published ? 'Yes' : 'No'}
                      </span>
                    </td>
                    <td className="blog-actions actions-cell" data-label="Actions">
                      <Link to={`/admin/blog/${post.id}/edit`} className="btn btn-sm btn-outline-secondary">
                        <i className="fa fa-pencil"></i> Edit
                      </Link>
                      <button onClick={() => handleTogglePublish(post.id)} className="btn btn-sm btn-outline-dark">
                        <i className="fa fa-eye"></i> Toggle
                      </button>
                      <button onClick={() => handleDelete(post.id)} className="btn btn-sm btn-danger">
                        <i className="fa fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="muted">No blog posts yet.</p>
        )}
      </div>
    </div>
  )
}

export default Blog
